import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3db1046a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "link-wrapper" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 공유하기 ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 문의하기 ")

import { useRouter } from 'vue-router'

import LeftArrow from '@/styles/icon/LeftArrow.vue'
import Text from '@/components/common/TextComponent.vue'
import { COLOR_SET } from '@/styles/variables'
import { showChannelTalk } from '@/utils/channelTalk'
import { shareByKakao } from '@/utils/kakao'


export default /*#__PURE__*/_defineComponent({
  name: 'Header',
  setup(__props) {

const router = useRouter()

const handleBack = () => {
  router.back()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(LeftArrow, { onClick: handleBack }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Text, {
        size: "14px",
        color: _unref(COLOR_SET).blue01,
        class: "share button",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(shareByKakao)('https://www.overtax.co.kr')))
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }, 8, ["color"]),
      _createVNode(Text, {
        size: "14px",
        color: _unref(COLOR_SET).blue01,
        onClick: _unref(showChannelTalk)
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }, 8, ["color", "onClick"])
    ])
  ]))
}
}

})